module.exports = __webpack_public_path__ + "static/media/razor-bump-stopper.37ee7c21.png";